import { useLocation } from "react-router-dom";

export const IncludesPath = (path) => {
  const location = useLocation();
  return location.pathname.includes(path);
};

export const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

export const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
    reader.onerror = (error) => {
      reject(error);
    };
  });
};




export const formatPrice = (number) => {
  const roundedValue = number?.toString().match(/^-?\d+(?:\.\d{0,4})?/)?.[0];

  if (!roundedValue) return "";
  const [integerPart, fractionalPart = ""] = roundedValue.split(".");
  const formatWithCommas = (num) => {
    if (num.length <= 4) return num;
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  };
  const formattedIntegerPart = formatWithCommas(integerPart);
  const formattedFractionalPart = fractionalPart.replace(/0+$/, ""); // Remove trailing zeros

  return formattedFractionalPart
    ? `${formattedIntegerPart}.${formattedFractionalPart}`
    : `${formattedIntegerPart}`; // Return integer part only if no fractional part
};
export const truncateToTwoDecimals = (value) => {
  const num = Number(value);
  if (isNaN(num)) return "";

  const truncated = Math.trunc(num * 100) / 100;
  return truncated.toFixed(2); // Ensures always two decimal digits
};

export const formatDepositPrice = (number) => {
  const roundedValue = Number(number)
    ?.toString()
    .match(/^-?\d+(?:\.\d{0,5})?/)?.[0];

  if (!roundedValue) return "";
  const [integerPart, fractionalPart = ""] = roundedValue.split(".");
  const formatWithCommas = (num) => {
    if (num.length <= 4) return num;
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  };
  const formattedIntegerPart = formatWithCommas(integerPart);
  const formattedFractionalPart = fractionalPart.padEnd(2, "0");

  return `${formattedIntegerPart}.${formattedFractionalPart}`;
};
export const formatCryptoPrice = (number) => {
  if (typeof number !== "string" && typeof number !== "number") return "0.00";
  const strValue = number
    .toString()
    .trim()
    .replace(/[^\d.-]/g, "");
  if (!strValue || isNaN(strValue)) return "0.00";
  const match = strValue.match(/^(-?\d+)(\.\d{0,6})?/);
  if (!match) return "0.00";

  const integerPart = match[1];
  let fractionalPart = match[2] ? match[2].slice(1) : "";
  fractionalPart = fractionalPart.replace(/0+$/, "");
  if (fractionalPart.length < 2) {
    fractionalPart = fractionalPart.padEnd(2, "0");
  }

  const formatWithCommas = (num) => num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return fractionalPart
    ? `${formatWithCommas(integerPart)}.${fractionalPart}`
    : `${formatWithCommas(integerPart)}.00`;
};


export const cutOffDecimal = (number, decimalPlaces) => {
  if (isNaN(number) || number === null || number === undefined) {
    return 0;
  }
  const multiplier = Math.pow(10, decimalPlaces);
  return Math.floor(number * multiplier) / multiplier;
};

export const spotPlusPremium = (spot, premium, premType) => {
  let sumTotal = 0;
  if (premType === "FLAT") {
    sumTotal = Number(formatPrice(spot)) + Number(formatPrice(premium)) || 0;
  } else {
    let premiumPercentage = Number(spot) * (Number(premium) / 100);
    sumTotal = Number(spot) + Number(premiumPercentage) || 0;
  }
  return sumTotal;
};



export const toFix = (value, n) => {
  if (value == null) value = 0;
  const v = value ? value.toString().split(".") : "0";
  if (n <= 0) return v[0].replace(/\B(?=(\d{4})+(?!\d))/g, ",");
  if (v.length == 1)
    return Number(v[0])
      ?.toFixed(n)
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  let f = v[1] || "";
  if (f.length > n)
    return `${v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.${f.substr(0, n)}`;
  while (f.length < n) f += "0";
  return `${v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",")}.${f}`;
};



export const formattedPrice = (price) => {
  if (isNaN(price) || price === null || price === undefined) {
    return 0;
  }
  if (price < 10000) {
    return `$${Number(price)?.toFixed(2)}`; // No commas for values less than 10,000
  }
  return price.toLocaleString("en-US", { style: "currency", currency: "USD" });
};



export const chartTooltip = {
  labelHTML: `<div style="background: rgba(23, 41, 53, 1); padding: 8px 12px; border-radius: 8px 8px 8px 0px">
							<h1 style='color: white; opacity: 0.6; font-size: 12px; line-height: 16px; font-weight: 500;'>{valueX.formatDate(\"dd MMM, yyyy\")}</h1> 
							<p style="color: white; font-size: 16px; line-height: 24px; font-weight: 600;">\${valueY}</p>
							</div>`,
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  pointerOrientation: "auto",
  paddingRight: 0,
  centerX: 1,
  centerY: 1,
};

export function getOS() {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/windows phone/i.test(userAgent)) return "Windows Phone";
  if (/windows/i.test(userAgent)) return "Windows";
  if (/android/i.test(userAgent)) return "Android";
  if (/iPad|iPhone|iPod/.test(userAgent)) return "iOS";
  if (/macintosh|mac os x/i.test(userAgent)) return "MacOS";
  if (/linux/i.test(userAgent)) return "Linux";

  return "Unknown";
}
